import { jsx as _jsx } from "react/jsx-runtime";
import { useReducer, useMemo, useEffect } from 'react';
import { assignmentState, assignmentContext, } from './AssignmentsContext';
import assignmentReducer from './AssignmentsReducer';
export function AssignmentProvider(props) {
    const { spectraData: spectra, children } = props;
    const [data, dispatch] = useReducer(assignmentReducer, assignmentState);
    const state = useMemo(() => ({ data, dispatch }), [data]);
    useEffect(() => {
        if (spectra) {
            dispatch({
                type: 'INITIATE_ASSIGNMENTS',
                payload: { spectra },
            });
        }
    }, [spectra]);
    return (_jsx(assignmentContext.Provider, { value: state, children: children }));
}
